import {V3Record} from 'data/helpers/V3Record.js'

export const Subscription = V3Record('subscription', {
  accountLevel: null,
  active: null,
  userId: null,
  updatedAt: null
})
